import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_ALIGNMENT_RESULTS } from "actions/alignmentResults";

const loadingAlignmentResults = (state = initialState.loadingAlignmentResults, action: any) => {
  switch (action.type) {
    case pending(GET_ALIGNMENT_RESULTS):
      return true;
    case fulfilled(GET_ALIGNMENT_RESULTS):
    case failed(GET_ALIGNMENT_RESULTS):
      return false;
    default:
      return state;
  }
};

export default loadingAlignmentResults;
